import { render, staticRenderFns } from "./smartsoft-frame.vue?vue&type=template&id=012a9763"
import script from "./smartsoft-frame.vue?vue&type=script&lang=js"
export * from "./smartsoft-frame.vue?vue&type=script&lang=js"
import style0 from "./smartsoft-frame.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/smartsoft/smartsoft-frame.vue
// module id = hQNB
// module chunks = 0